export const DeepLink_Hotel_Name = 'hotelName';
export const Special_Offer = 'specialOffer';
